module.exports = __webpack_public_path__ + "imgs/pinterest-white.ed4a4c769c61c3877f7e30f8699cdb47.svg";